module.exports = __webpack_public_path__ + "img/hexa_logo_branco.52e0ed5d.png";